// dropdown.js（ESM 版）— 下拉菜单 JS 控制
// 替代纯 CSS hover，消除点击延迟。鼠标悬停时展开，离开时延迟 150ms 关闭。
// DOM 依赖：.dropdown-upload、.dropdown-new（来自 desktop-tpl，需在 template 注入后加载）
// 下拉项点击分发统一走 create-actions.js runCreateAction（单一事实源，不传 ctx 行为不变）

import { runCreateAction } from './create-actions.js';

const dropdownTimers = {};

// 幂等标志挂在各绑定 DOM 元素上（元素级）：跨 chunk 模板重注入后新元素可重新绑定，
// 同 chunk 切换（DOM 不变）时不会重复绑定。

// 初始化下拉菜单事件绑定（须在 template 注入后由 list-entry 显式调用）
export function initDropdown() {
  document.querySelectorAll('.dropdown-upload, .dropdown-new').forEach(function(btn) {
    if (btn._dropdownBound) return;
    btn._dropdownBound = true;
    btn.addEventListener('mouseenter', function() {
      clearTimeout(dropdownTimers[btn.className]);
      btn.classList.add('dropdown-open');
    });
    btn.addEventListener('mouseleave', function() {
      // 延迟 150ms 关闭，避免鼠标快速划过时闪烁，同时确保点击能正常触发
      dropdownTimers[btn.className] = setTimeout(function() {
        btn.classList.remove('dropdown-open');
      }, 150);
    });
  });

  // 四个下拉项：剧情 / 文档 / 多维表格 / 文件夹，统一分发
  var ITEM_ACTIONS = [
    { id: 'btnNewPlot', action: 'plot' },
    { id: 'btnNewDoc', action: 'doc' },
    { id: 'btnNewBitable', action: 'bitable' },
    { id: 'btnNewFolder', action: 'folder' }
  ];
  ITEM_ACTIONS.forEach(function(cfg) {
    var el = document.getElementById(cfg.id);
    if (!el || el._bound) return;
    el._bound = true;
    el.addEventListener('click', function() {
      runCreateAction(cfg.action).catch(function() {});
    });
  });
}
